export const SAVE_OCCUPANCYDATECB = 'SAVE_OCCUPANCYDATECB';
export const SAVE_EXPIRYDATECB = 'SAVE_EXPIRYDATECB';
export const SAVE_CLAUSECB = 'SAVE_CLAUSECB';
export const SAVE_HOUSINGVALIDATION = 'SAVE_HOUSINGVALIDATION'
export const SAVE_EXPIRYDATE = 'SAVE_EXPIRYDATE';
export const SAVE_OCCUPANCYDATE = 'SAVE_OCCUPANCYDATE';

export function saveOccupancyDateCB(bol) {
    return {
        type: SAVE_OCCUPANCYDATECB,
        data: bol
    }
}
export function saveExpiryDateCB(bol) {
    return {
        type: SAVE_EXPIRYDATECB,
        data: bol
    }
}
export function saveClauseCB(bol){
    return {
        type: SAVE_CLAUSECB,
        data: bol
    }
}
export function saveHousingValidation(obj){
    return {
        type: SAVE_HOUSINGVALIDATION,
        data: obj
    }
}
export function saveOccupancyDate(inputValue){
    return {
        type: SAVE_OCCUPANCYDATE,
        data: inputValue
    }
}
export function saveExpiryDate(inputValue) {
    return {
        type: SAVE_EXPIRYDATE,
        data: inputValue
    }
}